import { z } from "zod";
import { CdtTreeMetaSchema } from "@CommonApi/cdt/trees/_treeId_/index";

export const RouteGetCdtCategories_categoryId_Trees = "/cdt/categories/:categoryId/trees";

export const ParamsCdtCategoryTreesSchema = z.object({
  categoryId: z.coerce.number().int().positive(),
});

export const CdtTreeSummarySchema = CdtTreeMetaSchema;
export const ResponseGetCdtCategoryTreesSchema = z.array(CdtTreeSummarySchema);

export type ParamsCdtCategoryTrees = z.infer<typeof ParamsCdtCategoryTreesSchema>;
export type CdtTreeSummary = z.infer<typeof CdtTreeSummarySchema>;
export type ResponseGetCdtCategoryTrees = z.infer<typeof ResponseGetCdtCategoryTreesSchema>;
